import type { PublicSportType } from '@/features/sport-types/api/sportTypesApi'

export function findSportType(
  sports: PublicSportType[],
  sportRef?: string | null
): PublicSportType | undefined {
  const normalized = sportRef?.trim()
  if (!normalized) {
    return undefined
  }

  return sports.find(
    sport =>
      sport.id === normalized ||
      sport.code.toUpperCase() === normalized.toUpperCase()
  )
}
